<template>
  <el-dialog
      title="升级包数据EXCEL导入预览窗口"
      :visible.sync="visible"
      width="1200px"
      @close="close">
    <div class="DataUpgrade-excel">
      <div class="container">
        
      
        <el-table
          :data="list"
          style="width: 100%;">
          <!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
          <el-table-column
            prop="id"
            label="ID"
            v-if="false">
          </el-table-column>
          <el-table-column
            fixed
            prop="obs_id"
            label="观测号"
            width="150">        
          </el-table-column>
          <el-table-column
            prop="level"
            label="数据级别"
            width="80">
          </el-table-column>   
          <el-table-column
            prop="file_ver"
            label="数据版本"
            width="160">
          </el-table-column>
          <el-table-column
            prop="archive_time"
            label="生成时间"
            width="160">
          </el-table-column>
          <el-table-column
            prop="file_path"
            label="升级包">
          </el-table-column>
                                                   
        </el-table>


      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Array,
      default(){
        return [];
      },
    },
  },
  data() {
    return {
      list:[],
      visible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.list = data;

    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.list,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
